export default [
    {
        path: '/categories/category-list/:filter?',
        name: 'category_list',
        component: () => import('@src/categories/category/category-list.vue'),
        meta: {
            title: 'Kategorien',
            role: 'ROLE_LIST_CATEGORY',
        },
    },
    {
        path: '/categories/category/:id?/:toCopy?',
        name: 'category',
        component: () => import('@src/categories/category/category.vue'),
        props(route) {
            return {
                id: route.params.id ? Number.parseInt(route.params.id) : null,
                toCopy: Boolean(route.params.toCopy),
            };
        },
        meta: {
            title: 'Kategorie anlegen',
            role: 'ROLE_EDIT_CATEGORY',
        },
    },

    // Facettengruppen
    {
        path: '/categories/facet-group-list/:filter?',
        name: 'facet_group_list',
        component: () => import('@src/categories/facet-group/facet-group-list.vue'),
        meta: {
            title: 'Facettengruppen',
            role: 'ROLE_LIST_FACET_GROUP',
        },
    },
    {
        path: '/categories/facet-group/:id?',
        name: 'facet_group',
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        component: () => import('@src/categories/facet-group/facet-group.vue'),
        meta: {
            role: 'ROLE_EDIT_FACET_GROUP',
        },
    },

    // Facetten
    {
        path: '/categories/facet-list/:filter?',
        name: 'facet_list',
        component: () => import('@src/categories/facet/facet-list.vue'),
        meta: {
            title: 'Facetten',
            role: 'ROLE_LIST_FACET',
        },
    },
    {
        path: '/categories/facet/:id?',
        name: 'facet',
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        component: () => import('@src/categories/facet/facet.vue'),
        meta: {
            role: 'ROLE_EDIT_FACET',
        },
    },
];
